import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { URLSearchParams } from '@angular/http';
import { ConfiguracoesProjeto, GenericHttpService, ParametrosService } from '../../../shared';
import { InstituicaoModel } from './';
import { LoadingService } from '../../../shared-layout/loading/loading.service';
import { FiltroBuscaInstituicoes } from './filtro-busca-instituicoes';
import { FiltroConsistenciaConsumidor } from '../../../shared/filter/filtro-consistencia-consumidor';
import { StatusRequisicao } from '../../../shared/model/status-requisicao';

@Injectable()
export class InstituicaoService {
  public _urlBase: string;
  public configuracao: ConfiguracoesProjeto;

  public instituicaoChange = new Subject<InstituicaoModel>();
  public instituicoesChange = new Subject<InstituicaoModel[]>();
  public instituicoesSelecionadaChange = new Subject<InstituicaoModel[]>();
  public instituicaoError = '';
  public totalInstituicoes = 0;

  public instituicaoModel: InstituicaoModel;
  public instituicoes: InstituicaoModel[];
  public instituicoesSelecionadas: InstituicaoModel[];

  constructor(
    private readonly genericHttpService: GenericHttpService<InstituicaoModel>,
    private readonly parametrosService: ParametrosService,
    private readonly loadingService: LoadingService
  ) {}

  get urlBase() {
    this.configuracao = this.parametrosService.getConfiguracao();
    this._urlBase = this.configuracao.uri + 'instituicao/';

    return this._urlBase;
  }

  get getUrlBaseCidadao() {
    this.configuracao = this.parametrosService.getConfiguracao();
    this._urlBase = this.configuracao.uri + 'instituicao-cidadao/';

    return this._urlBase;
  }

  getInstituicoes(): InstituicaoModel[] {
    return this.instituicoes.slice();
  }

  getInstituicao(): InstituicaoModel {
    return this.instituicaoModel;
  }

  setInstituicoesSelecionadas(instituicoes: InstituicaoModel[]) {
    this.instituicoesSelecionadas = instituicoes;
    const instituicoesClonadas = this.instituicoesSelecionadas.slice();
    this.instituicoesSelecionadaChange.next(instituicoesClonadas);
  }

  getInstituicoesSelecionadas(): InstituicaoModel[] {
    return this.instituicoesSelecionadas;
  }

  getInstituicoesFavoritas(objFiltro) {
    this.getInstituicoesGenericService(objFiltro, `listagem/paginado`);
  }

  getInstituicoesFavoritasPorFiltro(objFiltro) {
    this.getInstituicoesGenericService(objFiltro,`listagem-por-filtro/paginado`);
  }

  getPermissaoAltercao(filtro: FiltroConsistenciaConsumidor): Observable<any> {

    if (!filtro.consumidorId) {
      filtro.consumidorId = 0;
    }

    if (!filtro.areaId) {
      filtro.areaId = 0;
    }

    let searchParams: URLSearchParams = new URLSearchParams();
    searchParams.append('consumidorId', filtro.consumidorId.toString());
    searchParams.append('areaId', filtro.areaId.toString());

    const api = `consistencia/`;

    return this.genericHttpService.getAny(this.getUrlBaseCidadao.concat(api), searchParams);
  }

  getInstituicoesGenericService(filtro, api) {
    this.loadingService.exibirLoading(null);

    let searchParams: URLSearchParams = new URLSearchParams();

    if(filtro.etapa != null) {
        searchParams.append('Etapa', filtro.etapa != null ? filtro.etapa.toString() : "");
      }

    searchParams.append('Municipio', filtro.municipio != null ? filtro.municipio.toString() : "");
    searchParams.append('Area', filtro.area != null ? filtro.area.toString() : "");
    searchParams.append('RazaoSocial', filtro.razaosocial != null ? filtro.razaosocial.toString() : "");
    searchParams.append('page', filtro.page.toString());
    searchParams.append('pageSize', filtro.pageSize.toString());

    this.genericHttpService.getAny(this.urlBase.concat(api), searchParams).subscribe(
      (data: any) => {
        this.instituicoes = <InstituicaoModel[]>data.list;
        this.totalInstituicoes = data.totalCount;
        this.instituicaoError = '';
        this.instituicoesChange.next(this.instituicoes.slice());
      },
      (error: any) => {
        this.instituicoes = [];
        this.totalInstituicoes = 0;

        // Apresenta a mensagem de erro para o usuário.
        let erro = error as StatusRequisicao;
        this.instituicaoError = erro.motivo;

        this.instituicoesChange.next(this.instituicoes.slice());
        this.loadingService.esconderLoading();
      },
      () => {
        this.loadingService.esconderLoading();
      }
    );
  }

  public getListagemInstituicoes(filtro : FiltroBuscaInstituicoes): Observable<InstituicaoModel[]> {
    return this.genericHttpService.getAllParamFull(this.urlBase + `listagem`,filtro);
  }
}



// WEBPACK FOOTER //
// ./src/app/restrito/instituicao/shared/instituicao.service.ts